import { render, staticRenderFns } from "./ClientPaymentDetails.vue?vue&type=template&id=f3442680&"
import script from "./ClientPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./ClientPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports